import React from "react";
import { Flex, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FORUM, TRANSITION } from "../Theme/styles";

const SidebarLink = ({ title, icon, path, active }) => {
  const selected = active === path;

  return (
    <Link to={path} style={{ textDecoration: "none", width: "100%" }}>
      <Flex
        align="center"
        gap={3}
        px={4}
        py={2.5}
        cursor="pointer"
        position="relative"
        color={selected ? FORUM.tekstJasny : FORUM.tekstPrzygaszony}
        bg={selected ? FORUM.panelJasny : "transparent"}
        transition={TRANSITION}
        _hover={{ bg: FORUM.panel, color: FORUM.tekstJasny }}
        _before={{
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "3px",
          bg: selected ? "#6C99FF" : "transparent",
          transition: TRANSITION,
        }}
      >
        <Icon as={icon} boxSize="18px" flexShrink={0} />
        <Text fontSize="sm" fontWeight={selected ? "600" : "400"} noOfLines={1}>
          {title}
        </Text>
      </Flex>
    </Link>
  );
};

export default SidebarLink;
